<template>
  <div>
    <div class="course-item card p-3" @click="emitClickEvent">
      <img :src="image" class="" />
      <div class="card-body p-0 mt-3">
        <div class="course-title">
          {{ title }}
        </div>

        <div class="row">
          <div class="col-md-12 course-price">
            <span class="">
              {{ formattedPrice }}
            </span>
          </div>
        </div>

        <div class="row mt-4">
          <!-- <div class="col-md-12"> -->
          <!-- <selector
                        id="count-sel"
                        name="count-sel"
                        mandatory="false"
                        :data="count"
                        valuefield="count_id"
                        textfield="count_name"
                        inlinerows="false"
                        ref="countSelector"
                    ></selector> -->
          <!-- </div> -->
          <div class="action-btn-container col-md-12">
            <my-button fa="shopping-cart" :label="$t(LangConstants.buy_button_label)" variant="solid-primary" classes="pl-5 pr-5 buy-btn" height="48px" faIconColor="#ffffff" faIconSize="20px" faIconWeight="400" fapos="left"></my-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../../assets/scss/shopcourseitem.scss";
import MyButton from "../atoms/Button.vue";
import Common from "../../functions/index";
import Constants from "../../constants/index";

export default {
  name: "shop-course-item",

  props: {
    id: {
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    price: {
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    link: {
      required: true,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formattedPrice() {
      if (this.$props.price) {
        return Common.formatMoney(this.$props.price, this.currency);
      } else {
        return "00.00";
      }
    },

    LangConstants() {
      return Constants;
    },
  },
  methods: {
    emitClickEvent() {
      this.$emit("click", this.$props.id);
    },
  },

  setup() {},

  components: {
    // Selector,
    MyButton,
  },
};
</script>
